export const adminT = {
  pt: {
    dashboard: "Painel",
    products: "Produtos",
    categories: "Categorias",
    team: "Equipa",
    partners: "Parceiros",
    enquiries: "Pedidos",
    settings: "Definições",
    logout: "Sair",
    viewSite: "Ver Site",
    login: "Entrar",
    loginTitle: "Área de Administração",
    loginSubtitle: "Aceda ao painel de gestão da AgroLink",
    email: "Email",
    password: "Palavra-passe",
    loginError: "Email ou palavra-passe inválidos",
    add: "Adicionar",
    edit: "Editar",
    delete: "Eliminar",
    save: "Guardar",
    saving: "A guardar...",
    cancel: "Cancelar",
    search: "Pesquisar...",
    confirmDelete: "Tem a certeza que deseja eliminar?",
    confirmDeleteDesc: "Esta ação não pode ser desfeita.",
    saved: "Guardado com sucesso",
    deleted: "Eliminado com sucesso",
    error: "Ocorreu um erro",
    name: "Nome",
    namePt: "Nome (PT)",
    nameEn: "Nome (EN)",
    slug: "Slug (URL)",
    category: "Categoria",
    statusLabel: "Estado",
    active: "Ativo",
    draft: "Rascunho",
    featured: "Destaque",
    availability: "Disponibilidade",
    inStock: "Em Stock",
    onRequest: "Sob Consulta",
    shortDescPt: "Descrição curta (PT)",
    shortDescEn: "Descrição curta (EN)",
    descPt: "Descrição (PT)",
    descEn: "Descrição (EN)",
    applicationsPt: "Aplicações (PT) — uma por linha",
    applicationsEn: "Aplicações (EN) — uma por linha",
    packagingPt: "Embalagem (PT)",
    packagingEn: "Embalagem (EN)",
    images: "Imagens (URLs, uma por linha)",
    specs: "Especificações",
    specLabelPt: "Rótulo (PT)",
    specLabelEn: "Rótulo (EN)",
    specValue: "Valor",
    addSpec: "Adicionar especificação",
    order: "Ordem",
    image: "Imagem (URL)",
    descCatPt: "Descrição (PT)",
    descCatEn: "Descrição (EN)",
    rolePt: "Cargo (PT)",
    roleEn: "Cargo (EN)",
    bioPt: "Biografia (PT)",
    bioEn: "Biografia (EN)",
    photo: "Fotografia (URL)",
    logo: "Logótipo (URL)",
    website: "Website",
    statusNew: "Novo",
    statusInProgress: "Em Andamento",
    statusClosed: "Fechado",
    all: "Todos",
    noData: "Sem registos",
    contactInfo: "Informações de Contacto",
    phoneAngola: "Telefone Angola",
    phoneNamibia: "Telefone Namíbia",
    whatsappAngola: "WhatsApp Angola (número)",
    whatsappNamibia: "WhatsApp Namíbia (número)",
    company: "Empresa",
    country: "País",
    phone: "Telefone",
    interest: "Interesse",
    quantity: "Quantidade",
    message: "Mensagem",
    date: "Data",
    view: "Ver",
    totalProducts: "Total de Produtos",
    newEnquiries: "Novos Pedidos",
    totalEnquiries: "Total de Pedidos",
    teamMembers: "Membros da Equipa",
    recentEnquiries: "Pedidos Recentes",
    welcome: "Bem-vindo ao painel AgroLink",
  },
  en: {
    dashboard: "Dashboard",
    products: "Products",
    categories: "Categories",
    team: "Team",
    partners: "Partners",
    enquiries: "Enquiries",
    settings: "Settings",
    logout: "Log out",
    viewSite: "View Site",
    login: "Log in",
    loginTitle: "Admin Area",
    loginSubtitle: "Access the AgroLink management panel",
    email: "Email",
    password: "Password",
    loginError: "Invalid email or password",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    search: "Search...",
    confirmDelete: "Are you sure you want to delete?",
    confirmDeleteDesc: "This action cannot be undone.",
    saved: "Saved successfully",
    deleted: "Deleted successfully",
    error: "An error occurred",
    name: "Name",
    namePt: "Name (PT)",
    nameEn: "Name (EN)",
    slug: "Slug (URL)",
    category: "Category",
    statusLabel: "Status",
    active: "Active",
    draft: "Draft",
    featured: "Featured",
    availability: "Availability",
    inStock: "In Stock",
    onRequest: "On Request",
    shortDescPt: "Short description (PT)",
    shortDescEn: "Short description (EN)",
    descPt: "Description (PT)",
    descEn: "Description (EN)",
    applicationsPt: "Applications (PT) — one per line",
    applicationsEn: "Applications (EN) — one per line",
    packagingPt: "Packaging (PT)",
    packagingEn: "Packaging (EN)",
    images: "Images (URLs, one per line)",
    specs: "Specifications",
    specLabelPt: "Label (PT)",
    specLabelEn: "Label (EN)",
    specValue: "Value",
    addSpec: "Add specification",
    order: "Order",
    image: "Image (URL)",
    descCatPt: "Description (PT)",
    descCatEn: "Description (EN)",
    rolePt: "Role (PT)",
    roleEn: "Role (EN)",
    bioPt: "Bio (PT)",
    bioEn: "Bio (EN)",
    photo: "Photo (URL)",
    logo: "Logo (URL)",
    website: "Website",
    statusNew: "New",
    statusInProgress: "In Progress",
    statusClosed: "Closed",
    all: "All",
    noData: "No records",
    contactInfo: "Contact Information",
    phoneAngola: "Angola Phone",
    phoneNamibia: "Namibia Phone",
    whatsappAngola: "WhatsApp Angola (number)",
    whatsappNamibia: "WhatsApp Namibia (number)",
    company: "Company",
    country: "Country",
    phone: "Phone",
    interest: "Interest",
    quantity: "Quantity",
    message: "Message",
    date: "Date",
    view: "View",
    totalProducts: "Total Products",
    newEnquiries: "New Enquiries",
    totalEnquiries: "Total Enquiries",
    teamMembers: "Team Members",
    recentEnquiries: "Recent Enquiries",
    welcome: "Welcome to the AgroLink panel",
  },
};

export const useAdminT = (lang) => (key) => adminT[lang]?.[key] ?? adminT.en[key] ?? key;
